import {
    createContext,
    Dispatch,
    ReactNode,
    SetStateAction,
    useEffect,
    useMemo,
    useState,
} from 'react'
import UtilitiesService from '../services/UtilitiesService'
import { AppConfig } from '../models/shared'

interface Props {
    children: ReactNode
}

export const StatisticsContext = createContext({
    startDate: '',
    setStartDate: () => {},
    endDate: '',
    setEndDate: () => {},
    carreer: '',
    setCarreer: () => {},
    allCarreers: [],
    roleNumbers: '',
    setRoleNumbers: () => {},
} as {
    startDate: string
    setStartDate: Dispatch<SetStateAction<string>>
    endDate: string
    setEndDate: Dispatch<SetStateAction<string>>
    carreer: string
    setCarreer: Dispatch<SetStateAction<string>>
    allCarreers: string[]
    roleNumbers: string
    setRoleNumbers: Dispatch<SetStateAction<string>>
})

const StatisticsProvider = ({ children }: Props) => {
    const [startDate, setStartDate] = useState<string>('')
    const [endDate, setEndDate] = useState<string>('')
    const [carreer, setCarreer] = useState<string>('')
    const [allCarreers, setAllCarreers] = useState<string[]>([])
    const [roleNumbers, setRoleNumbers] = useState<string>('10')

    useEffect(() => {
        new UtilitiesService().getAppConfig().then((response) => {
            if (response.status !== 200) return
            const config = response.data as AppConfig
            setAllCarreers(config.careers)
        })
    }, [])

    const providerValues = useMemo(
        () => ({
            startDate,
            setStartDate,
            endDate,
            setEndDate,
            carreer,
            setCarreer,
            allCarreers,
            roleNumbers,
            setRoleNumbers,
        }),
        [
            startDate,
            setStartDate,
            endDate,
            setEndDate,
            carreer,
            setCarreer,
            allCarreers,
            roleNumbers,
            setRoleNumbers,
        ],
    )

    return (
        <StatisticsContext.Provider value={providerValues}>{children}</StatisticsContext.Provider>
    )
}

export default StatisticsProvider
